import { RecipeCounter } from "@core";

export class GenericPage {
  _buttonList;
  _domFragment;
  _routeWrapper;

  /**
   *
   * @param {string} template html as string
   * @param {Array<{id: string, route: string}>} buttonList list of all existing miam page for retailer (optional)
   */
  constructor(routeWrapper, template, buttonList = null) {
    this._routeWrapper = routeWrapper;
    this._domFragment = document
      .createRange()
      .createContextualFragment(template);
    this._buttonList = buttonList;
    this._initButtonListeners();
  }

  /**
   * Add listener to buttons and call backs
   * we can not use onclik in template beacause it's a literal string
   * and function's name'll change after compilation.
   * Pass fonction inside "${ }" will pass value and not reference of the funtion
   * for this reason it will not work either
   */
  _initButtonListeners() {
    if (this._buttonList == null) return;
    this._buttonList.foreach((button) => {
      this._bindOrHideButton(button);
    });
  }

  /**
   * init button listener , add a recipe counter if needeed, and hide
   * it if route is not already avalaible on hosting retailer
   * @param {{id: string, route: string}} button current button info
   */
  _bindOrHideButton(button) {
    const domButton = document.getElementById(button.id);
    if (!domButton) return;
    if (this._routeWrapper.doesRouteExists(button.route)) {
      button.addEventListener(
        "click",
        () => {
          this._routeWrapper.navigate(button.route);
        },
        false
      );
      if (this._isCounterParentElem(button)) {
        domButton.appendChild(
          RecipeCounter.initCounter(window.mealz.basket.recipeCount()?.value)
        );
      }
    } else {
      domButton.style.display = "none";
    }
  }

  /**
   * @param {{id: string, route: string}} button
   * @returns true is button have to hold a recipe counter
   */
   _isCounterParentElem(button) {
    return button.route === "mes-repas";
  }

  /**
   *  @param {DomElement} placeholder  of the container to replace
   */
  injectPageFragment(placeholderClass) {
    if (placeholderClass) {
      placeholderClass.replaceWith(this._domFragment);
    }
  }
}
